import { render, staticRenderFns } from "./InputEmailChips.vue?vue&type=template&id=7b79f7ea"
import script from "./InputEmailChips.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputEmailChips.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports